import React from "react";
import { Hero, EventsCards } from "../../components";
import { eventsData, heroData } from "../../assets/data/eventsData";

export default function Events(props) {
	return (
		<>
			<Hero data={heroData} />

			<section className="no-p bp">
				<EventsCards data={eventsData} />
			</section>
		</>
	);
}
